var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',[_c('b-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("\n                            Welkom "+_vm._s(_vm.userName)+"!\n                        ")]},proxy:true}])},[_c('DefaultUserLocaleResetButton')],1)],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }